import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiGrid-item': {
      [theme.breakpoints.down('md')]: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
  submit: {
    display: 'flex',
    justifyContent: 'end',
    width: '100%',
    marginLeft: 'auto',
    gap:'15px',
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(0),
    },
  },
  chips: {
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2),
    },
  },
  addButton: {
    color: theme.palette.secondary.dark,
  },
  chip: {
    marginBottom: 8,
    marginInlineEnd: 5,
    backgroundColor: '#f6f7f8',
    maxWidth: '100%',
    '&:hover': {
      backgroundColor: '#eaeef3',
    },
    '&.disableDelete': {
      backgroundColor: '#e2e5e9',
    },
  },
  deleteAllChips: {
    background: 'rgb(243 33 33 / 7%)',
    marginBottom: 8,
    marginInlineEnd: 5,
    '&:hover': {
      backgroundColor: 'rgb(243 33 33 / 15%)',
    },
    '&:focus': {
      backgroundColor: 'rgb(243 33 33 / 15%)',
    },
  },
  deleteAllChipsText: {
    color: 'red',
    fontSize: 12,
    marginBottom: -1,
  },
  chipTitle: {
    marginRight: 3
  },
  errorDate: {
    color: 'red',
    fontSize: '11px',
    textAlign: 'right',
    [theme.breakpoints.down('lg')]: {
      marginTop: '24px',
    },
  },
  mesageError: {
    marginLeft: '5px',
  },
}));